/** API status values on essay_versions.status */
const API = {
	DRAFT: 'draft',
	SUBMITTED: 'submitted_for_review',
	REVISION: 'revision_requested',
	UPDATING: 'updating',
	APPROVED: 'approved',
}

const LABEL = {
	[API.DRAFT]: 'Draft',
	[API.SUBMITTED]: 'Pending review',
	[API.REVISION]: 'Revision Needed',
	[API.UPDATING]: 'Updating',
	[API.APPROVED]: 'Approved',
}

export const ESSAY_VERSION_STATUS_PRIORITY = {
	[API.SUBMITTED]: 1,
	[API.REVISION]: 2,
	[API.UPDATING]: 3,
	[API.APPROVED]: 4,
	draft_only: 5,
}

export function normalizeEssayVersionStatus(apiStatus) {
	const s = String(apiStatus || '')
		.trim()
		.toLowerCase()
	if (s === API.SUBMITTED) return API.SUBMITTED
	if (s === API.REVISION) return API.REVISION
	if (s === API.UPDATING) return API.UPDATING
	if (s === API.APPROVED) return API.APPROVED
	return 'draft_only'
}

export function compareEssayVersionsByPriorityAndDate(a, b) {
	const sa = normalizeEssayVersionStatus(a?.status)
	const sb = normalizeEssayVersionStatus(b?.status)
	const pa = ESSAY_VERSION_STATUS_PRIORITY[sa] || 999
	const pb = ESSAY_VERSION_STATUS_PRIORITY[sb] || 999
	if (pa !== pb) return pa - pb
	const ta = new Date(a?.updatedAt || 0).getTime()
	const tb = new Date(b?.updatedAt || 0).getTime()
	const da = Number.isFinite(ta) ? ta : 0
	const db = Number.isFinite(tb) ? tb : 0
	if (da !== db) return db - da
	return (Number(b?.versionNumber) || 0) - (Number(a?.versionNumber) || 0)
}

export function selectMainEssayVersion(versions) {
	const list = Array.isArray(versions) ? versions.filter(Boolean) : []
	if (!list.length) return null
	const sorted = [...list].sort(compareEssayVersionsByPriorityAndDate)
	return sorted[0] || null
}

/**
 * Human-readable status for the counselor side panel (matches design, English).
 * @param {string|null|undefined} apiStatus
 * @returns {string}
 */
export function mapEssayVersionStatusLabel(apiStatus) {
	const s = normalizeEssayVersionStatus(apiStatus)
	if (!s) return '—'
	return LABEL[s] || s.replace(/_/g, ' ')
}

export { API as ESSAY_VERSION_STATUS }
